import React from 'react'
import PropTypes from 'prop-types'

import { addUrlProps, UrlQueryParamTypes } from 'react-url-query'

import api from 'common/api'

import { Notifications } from '@scoir/messaging'

import './index.scss'

export class NotificationsCenter extends React.Component {
  static propTypes = {
    activeItemId: PropTypes.string,
    onChangeActiveItemId: PropTypes.func.isRequired,
  }
  componentDidMount() {
    document.title = 'Scoir - Notifications'
  }
  deleteNotification = (id) => api.delete(`/api/inbox/${id}`)
  getSpecificItem(id) {
    return api.get(`/api/inbox/${id}`)
  }
  loadInbox(amount) {
    return api.get(`/api/inbox?start=0&pageSize=${amount}`)
  }
  markAsRead(id) {
    return api.post(`/api/inbox/${id}`)
  }
  render() {
    const ROOT = import.meta.env.BASE_URL
    return (
      <Notifications
        className="notifications-route"
        activeItemId={this.props.activeItemId}
        onChangeActiveItemId={(activeId) => this.props.onChangeActiveItemId(activeId)}
        onDelete={this.deleteNotification}
        onLoadInbox={(cnt) => this.loadInbox(cnt)}
        onMarkAsRead={(id) => this.markAsRead(id)}
        onLoadItem={(id) => this.getSpecificItem(id)}
        messagesPath={`${ROOT}/message-center/messages`}
        notificationsPath={`${ROOT}/message-center/notifications`}
      />
    )
  }
}

const urlPropsQueryConfig = {
  activeItemId: { type: UrlQueryParamTypes.string },
}

export default addUrlProps({ urlPropsQueryConfig, addUrlChangeHandlers: true })(NotificationsCenter)
